{
    "AlarmonnewabandonedcallLabel": "Alarmacties",
    "NAME": "AbandonedCallAlarm",
    "AbandonedCallAlarm_SectionHeader": "Verlaten oproepalarm",
    "AbandonedCallAlarm_SectionPara": "U kunt een alarm activeren wanneer nieuwe verlaten oproepen plaatsvinden."
}